import { Link, useRouterState } from '@tanstack/react-router';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useCart } from '../lib/cart';
import { formatNumber } from '../lib/format';

export function CartFab() {
  const { t } = useTranslation();
  const items = useCart();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const pieceCount = items.length;
  const totalQty = items.reduce((s, i) => s + i.qty, 0);

  // Hide on the cart page itself and while there's nothing in the cart
  const hidden = pieceCount === 0 || pathname.startsWith('/cart');

  return (
    <AnimatePresence>
      {hidden ? null : (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ type: 'spring', stiffness: 360, damping: 28 }}
          className="fixed bottom-4 left-4 z-40"
        >
          <Link
            to="/cart"
            className="flex items-center gap-3 bg-oud-900 text-sand rounded-full pr-2 pl-5 py-2 shadow-quote border border-oud-700 hover:bg-oud-800 active:scale-[0.97] transition-all"
          >
            <div className="flex items-center gap-1.5">
              {Array.from({ length: Math.min(pieceCount, 4) }).map((_, i) => (
                <span
                  key={i}
                  className="w-1.5 h-1.5 rounded-full bg-gold"
                  aria-hidden
                />
              ))}
              {pieceCount > 4 ? <span className="text-[11px] text-gold font-bold">+</span> : null}
            </div>
            <span className="text-sm font-bold">{t('quote.cta_view_cart')}</span>
            <span className="flex items-center justify-center min-w-7 h-7 rounded-full bg-gold text-oud-900 text-xs font-black px-2">
              {formatNumber(totalQty)}
            </span>
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
